interface F7Route {
  route?: { path?: string };
  url?: string;
}

// Framework7 routes in memory and never touches the address bar, so the Umami
// tracker and recorder both see "/" forever and every report - pageviews, web
// vitals, heatmaps - collapses into one row. Writing the route into history
// ourselves is what feeds them a real path: both scripts patch replaceState,
// and the tracker turns each one into a pageview.
function syncAddressBar(screen: string): void {
  const { search, hash } = window.location;
  try {
    window.history.replaceState(window.history.state, '', `${screen}${search}${hash}`);
  } catch {
    // A blocked history write costs us the path, not the event.
  }
}

function routeChange(newRoute: F7Route): void {
  const screen = newRoute.route?.path ?? newRoute.url;
  if (!screen) return;
  syncAddressBar(screen);
}

export const screenTracking = { routeChange };
